// @ts-strict

import { Component, Input, OnInit } from '@angular/core';
import { ICampaignConfigFieldData, ISingleCampaign, SpecialCampaignData } from '@app/core/models/core-models';
import { UrlAddressConfigService } from '@services/url-address-config/url-address-config.service';
import { SelectValue } from '@app/shared/components/modal-inputs/select-input/select-input.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ISelectOption } from '@app/shared/types/inputs';

@Component({
  selector: 'app-generate-url-modal',
  templateUrl: './generate-url-modal.component.html',
  styleUrls: ['./generate-url-modal.component.scss']
})
export class GenerateUrlModalComponent implements OnInit {
  @Input() configID?: number;
  @Input() configURL?: string;
  @Input() currentCampaign?: ISingleCampaign | SpecialCampaignData;
  @Input() configurationType?: string;

  public trackingDomains: ICampaignConfigFieldData = { values: [], system_name: 'domain' };
  public defaultTrackingDomainValue?: number;
  public generatedURL: string = '';
  public landings: ISelectOption[] = [];
  public selectedLandingPage?: number;

  private trackingDomain = { id: 0 };
  private originalURL: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private configService: UrlAddressConfigService
  ) {}

  ngOnInit(): void {
    this.getProgramDomains();
    if (this.configURL) {
      this.generatedURL = this.configURL;
      this.originalURL = this.generatedURL;
      console.log(this.configurationType);
      if (this.configurationType !== 'products') {
        this.getProgramLandings(this.configID || 0);
      }
    }
  }

  public getValue(event: SelectValue): void {
    const currentDomain = this.generatedURL.split('/')[2];
    this.trackingDomain.id = event.value;
    this.defaultTrackingDomainValue = this.trackingDomain.id;
    const newDomain = ((this.trackingDomains.values as Record<string, any>[]) || []).find(domain => domain.id === event.value);
    if (newDomain) {
      this.generatedURL = this.generatedURL.replace(currentDomain, newDomain.domain.split('/')[2]);
    }
  }

  public getSubs(arrayOfSubs: Array<string>): void {
    arrayOfSubs = arrayOfSubs.filter(el => el);
    this.generatedURL = this.originalURL + '?' + arrayOfSubs.join('&') + (this.selectedLandingPage ? '&ld=' + this.selectedLandingPage : '');
  }

  public getLanding(event: any): void {
    if (event.id) {
      this.selectedLandingPage = event.id;
      if (this.generatedURL.includes('&ld=')) {
        this.generatedURL = this.generatedURL.replace('&ld=' + this.selectedLandingPage, '');
      }
      this.generatedURL = this.generatedURL + '&ld=' + this.selectedLandingPage;
    } else {
      this.selectedLandingPage = undefined;
      this.generatedURL = this.generatedURL.replace(/[?&]ld=[^&]*/g, '');
    }
  }

  private getProgramLandings(configID: number): void {
    this.configService.getEditConfigData(this.currentCampaign?.id || 0, configID).subscribe(res => {
      if (res.data?.landings && res.data?.landings.length > 0) {
        const tempArray: ISelectOption[] = [];
        res.data.landings.forEach(item => {
          tempArray.push({ id: item.id, value: item.id, name: item.name });
        });
        this.landings = tempArray;
      }
    });
  }

  private getProgramDomains(): void {
    this.configService
      .getProgramDomains(this.currentCampaign?.id || 0, this.configID || 0, this.configurationType === 'products' ? 'banners' : 'deeplink')
      .subscribe(res => {
        this.trackingDomains.values = (res.data?.domains || []).map(domain => ({ ...domain, value: domain.domain || '' }));
        this.trackingDomains.system_name = 'domain';
        const firstDomain = this.trackingDomains.values[0]?.id;
        this.defaultTrackingDomainValue = typeof firstDomain === 'string' ? Number(firstDomain) : typeof firstDomain === 'number' ? firstDomain : 0;
      });
  }
}
